import { render, staticRenderFns } from "./plattransactiondetais-set-chongzhi.vue?vue&type=template&id=1a2a5d2a&"
import script from "./plattransactiondetais-set-chongzhi.vue?vue&type=script&lang=js&"
export * from "./plattransactiondetais-set-chongzhi.vue?vue&type=script&lang=js&"
import style0 from "./plattransactiondetais-set-chongzhi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports